<template>
        <span data-v-aed20922=""
              @click.prevent.stop="addOrRemove"
              class="button-share inline-flex">
            <svg data-v-aed20922="" aria-label="Megosztás" class="icon">
                <slot name="added" v-if="existInTheCollection">
                    <a
                        href="#"
                        @click.prevent=""
                        class="product-icon secondary secondary--text text--secondary"
                        :class="noMargin ? '' : 'mr-2'"
                        :title="__('Click to remove the product from your wishlist')"
                    >
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-heart-full"></use>
                        <svg class="icon product-heart-icon exists">
                            <use xlink:href="#product-heart-icon"></use>
                        </svg>
                    </a>
                </slot>
                <slot v-else>
                    <a
                        href="#"
                        @click.prevent=""
                        class="product-icon"
                        :class="noMargin ? '' : 'mr-2'"
                        :title="__('Click to add the product to your wishlist')"
                    >
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-heart"></use>
                        <svg class="icon product-heart-icon">
                            <use xlink:href="#product-heart-icon"></use>
                        </svg>
                    </a>
                </slot>
            </svg>
        </span>
</template>

<script>
import axios from 'axios'

export default {
    name: 'AddToWishlistCollection',

    props: {
        listCollection: {
            type: String,
            required: true,
        },
        item: {
            type: Object,
            required: true
        },
        existInTheListCollection: {
            type: Boolean,
            required: true,
            default: () => false
        },
        addedMessage: {
            type: String,
            default: 'Added'
        },
        removedMessage: {
            type: String,
            default: 'Removed'
        },
        noMargin: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            existInTheCollection: this.existInTheListCollection,
            sending: false
        }
    },

    methods: {
        async addToListCollection() {
            try {
                this.sending = true
                await axios.post(`/list-collections/${this.listCollection}`, this.item)

                this.toggleExistInTheListCollection()
                this.$emit('added')
                this.showMessage(this.addedMessage)
            } catch (error) {
                if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                    this.showMessage('A funkció használatához bejelentkezés szükséges!')
                }
            }

            this.sending = false
        },

        async removeFromListCollection() {
            try {
                this.sending = true
                await axios.delete(`/list-collections/${this.listCollection}`, {data: this.item})

                this.toggleExistInTheListCollection()
                this.$emit('removed')
                this.showMessage(this.removedMessage)
            } catch (error) {
                if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                    this.showMessage('A funkció használatához bejelentkezés szükséges!')
                }
            }

            this.sending = false
        },

        addOrRemove() {
            if (this.sending) return

            this.existInTheCollection
                ? this.removeFromListCollection()
                : this.addToListCollection()
        },

        toggleExistInTheListCollection() {
            this.existInTheCollection = !this.existInTheCollection

        },

        showMessage(message) {
            Snackbar.show({
                text: message,
                pos: 'bottom-center',
                actionText: '×',
                actionTextColor: '#332e2b',
                backgroundColor: '#b2d630',
                textColor: '#332e2b'
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.exists {
    --color1: var(--secondary);
    --color2: var(--red);
}
</style>
